import React from 'react'
import SideNav from './SideNav'

const WhyMeHome = () => {
  return (
    <div>
      <>
        <div className="page-header-why-mehome parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Why MeHome
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                   

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      <b>MeHome</b> is more than a design company — it’s a partnership built on trust, creativity, 
                      and craftsmanship. We bring together a team of designers, engineers, and artisans 
                      who share one mission: to create spaces that feel as good as they look.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why Clients <span>Choose MeHome</span>
                    </h2>

                    <ul>
                      <li>15+ years of proven experience in interior design and construction.</li>
                      <li>End-to-end services — from concept to handover.</li>
                      <li>Designs tailored to lifestyle, function, and emotion.</li>
                      <li>High-quality materials and workmanship.</li>
                      <li>Transparent pricing and on-time project delivery.</li>
                      <li>Dedicated design, build, and aftercare teams.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        What <span>Sets Us Apart</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🎯</div>
                        <div className="why-choose-item-content">
                          <h3>Personalized Design Approach</h3>
                          <p>
                            Every space we design starts with your story — your lifestyle, your dreams, your rhythm.
                            We turn that into a tangible design that truly belongs to you.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🧠</div>
                        <div className="why-choose-item-content">
                          <h3>Creative & Practical Solutions</h3>
                          <p>
                            Our designs balance aesthetics and function — modern ideas crafted for everyday comfort.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🧱</div>
                        <div className="why-choose-item-content">
                          <h3>End-to-End Project Handling</h3>
                          <p>
                            From interior design to construction and décor — everything is managed seamlessly by one team.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🕓</div>
                        <div className="why-choose-item-content">
                          <h3>Timely Execution</h3>
                          <p>
                            Our organized workflow ensures your project is delivered exactly when promised — without compromises.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Innovation & Quality</h3>
                          <p>
                            We constantly explore new trends, materials, and technologies to deliver modern and sustainable designs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our <span>Work Philosophy</span>
                      </h2>
                    </div>
                    <p className="wow fadeInUp">
                      Every MeHome project is guided by precision, passion, and purpose. 
                      We don’t believe in one-size-fits-all — we design with individuality, 
                      crafting homes that blend functionality, comfort, and timeless beauty. 
                      Our success is measured by your happiness and trust.
                    </p>
                     
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why <span> You’ll Love Working With Us</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Transparent Collaboration:</b> We keep you informed and involved at every step.</li>
                        <li><b>Skilled Team:</b> Expert designers, craftsmen, and engineers working in sync.</li>
                        <li><b>Commitment to Excellence:</b> We treat every project as if it were our own home.</li>
                        <li><b>Strong Aftercare:</b> Support doesn’t end at delivery — we stay connected for maintenance and upgrades.</li>
                        <li><b>Client Loyalty:</b> 80% of our new projects come from referrals — a testament to our quality and trust.</li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default WhyMeHome
